<template>
  <div class="pt-4">
    <v-dialog
      v-model="remove_user_dialog"
      width="500"
    >
      <v-card>
        <v-card-title class="modal-header--style">
          <span class="headline">Remove user</span>
        </v-card-title>

        <v-card-text>
          <div class="text-md-center pt-4 pb-3 font-size-16">
            Are you sure you want to remove <strong>{{ selected_user.username }}</strong> from <strong>{{ $route.params.workspace_name }}</strong>?
          </div>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <div class="pb-2 pr-3">
            <v-btn class="text-capitalize" @click="cancelRemoveUser">Cancel</v-btn>
            <v-btn class="text-capitalize" color="primary" @click="removeUser">Remove</v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-card>
      <v-card-title>
        <!-- <v-toolbar-title><span style="text-transform: uppercase;">{{ $route.params.workspace_name }}</span>'s users</v-toolbar-title> -->
        <v-toolbar-title>Users</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-dialog v-model="add_user_dialog" max-width="500px">
          <v-btn slot="activator" color="primary" class="mb-2 text-capitalize">Add User</v-btn>
          <v-card>
            <v-card-title class="modal-header--style">
              <span class="headline">Add User</span>
            </v-card-title>

            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 sm12 md12>
                  <v-text-field v-model="new_user.username"
                                label="First and last name*"
                                :rules="[rules.required]"
                                required></v-text-field>
                </v-flex>
                <v-flex xs12 sm12 md12>
                  <v-text-field v-model="new_user.email"
                                label="E-mail*"
                                :rules="[rules.required, rules.email]"
                                required></v-text-field>
                </v-flex>
                <v-flex xs12 sm12>
                  <v-select
                    v-model="new_user.account_type"
                    :items="['Admin', 'Regular user']"
                    label="Account type*"
                    :rules="[rules.required]"
                    required
                  ></v-select>
                </v-flex>
                <v-spacer></v-spacer>
                <v-spacer></v-spacer>
                <v-flex xs12 sm12 md12>
                  <v-text-field
                    v-model="new_user.password"
                    :append-icon="show1 ? 'visibility_off' : 'visibility'"
                    :rules="[rules.required, rules.min]"
                    :type="show1 ? 'text' : 'password'"
                    name="input-10-1"
                    label="Password"
                    hint="At least 6 characters"
                    counter
                    @click:append="show1 = !show1"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm12 md12>
                  <v-text-field
                    v-model="new_user.password_confirmation"
                    :append-icon="show2 ? 'visibility_off' : 'visibility'"
                    :rules="[rules.required, rules.min]"
                    :type="show2 ? 'text' : 'password'"
                    name="input-10-1"
                    label="Password Confirmation"
                    hint="At least 6 characters"
                    counter
                    @click:append="show2 = !show2"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>

            <v-card-actions>
              <v-spacer></v-spacer>
              <div class="pb-2 pr-3">
                <v-btn class="text-capitalize" @click="cancelAddUser">Cancel</v-btn>
                <v-btn class="text-capitalize" color="primary" @click="addUser">Add User</v-btn>
              </div>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :loading="loadingDataTable"
        :items="workspace_users"
      >
        <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
        <template slot="items" slot-scope="props">
          <td>{{ props.item.username }}</td>
          <td class="text-xs-center">{{ props.item.email }}</td>
          <td class="text-xs-center">
            <div v-if="props.item.is_admin && props.item.is_staff">Staff</div>
            <div v-if="props.item.is_admin && !props.item.is_staff">Admin</div>
            <div v-else>Regular</div>
          </td>
          <td class="text-xs-center">
            <div class="active-class" v-if="props.item.is_active">YES</div>
            <div class="inactive-class" v-else>NO</div>
          </td>
          <td class="text-xs-center">12/01/19</td>
          <td class="text-xs-right">
           <!-- <v-icon class="icon-style" @click="editUserDialog(props.item)" color="primary">edit</v-icon>
            <v-icon class="icon-style" @click="editUserPermissionsDialog(props.item)" color="primary">
              vpn_key
            </v-icon> -->
            <v-icon class="icon-style" @click="removeUserDialog(props.item)" color="primary">delete</v-icon>
          </td>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning">
          Your search for "{{ search }}" found no results.
        </v-alert>
      </v-data-table>
    </v-card>
  </div>
</template>

<style>

  .active-class {
    color: #5EE2A0;
  }

  .inactive-class {
    color: #FF8474;
  }

  .font-size-16 {
    font-size: 16px;
  }

  .uppercase {
    text-transform: uppercase;
  }

  .primary {
    background: #0033A0 !important;
  }

  .modal-header--style {
    background: #0033A0 !important;
    color: white !important;
  }
</style>

<script>
  import {axiosInstance} from '../../axios-auth'

  export default {
    data() {
      return {
        show1: false,
        show2: false,
        rules: {
          required: value => !!value || 'Required.',
          min: v => v.length >= 6 || 'Min 6 characters',
          email: value => {
            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            return pattern.test(value) || 'Invalid e-mail.'
          }
        },
        is_loading: true,
        edit_user: {
          user_name: "",
          email: "",
          account_type: "",
          new_password: "",
          new_password_confirmation: ""
        },
        selected_user: "",
        new_user: {
          username: "",
          email: "",
          account_type: "",
          password: "",
          password_confirmation: ""
        },
        dialog: false,
        search: '',
        headers: [
          {
            text: 'User',
            align: 'left',
            value: 'user'
          },
          {text: 'E-mail', align: 'center', value: 'email'},
          {text: 'Account type', align: 'center', value: 'account-type'},
          {text: 'Active', align: 'center', value: 'active'},
          {text: 'Creation date', align: 'center', value: 'creation-date'},
          {text: ' ', align: 'right', value: ''}
        ],
        workspace_users: [],

        add_user_dialog: false,
        edit_user_dialog: false,
        edit_user_permissions_dialog: false,
        remove_user_dialog: false,
        item_index: ''
      }
    },
    name: "WorkspaceUsers",
    methods: {
      clear () {
        this.new_user.username = '';
        this.new_user.email = '';
        this.new_user.password = '';
        this.new_user.password_confirmation = '';
        this.new_user.account_type = null;
      },
      addUser() {
        let self = this,
          url = 'workspaces/' + parseInt(self.$route.params.workspace_id) + '/users/';

        self.is_loading = true;

        let params = {
          username: self.new_user.username,
          email: self.new_user.email,
          password: self.new_user.password,
          first_name: "",
          last_name: "",
          is_admin: false
        };

        if (self.new_user.username === "Admin") {
          params.is_admin = true;
        } else {
          params.is_admin = false;
        }

        axiosInstance.post(url, params).then(function (response) {
          //  self.is_loading = false;
          self.$toastr.s("Added new user successfully");
          self.getUsers();
        }).catch(function (err) {
          //  self.is_loading = false;
          self.$toastr.e("Error saving new user");
          console.log(err)
        });

        self.add_user_dialog = false
        // add Refresh after post
      },
      cancelAddUser() {
        // Clear Add User
        const self = this;

        self.add_user_dialog = false;
        self.clear();
      },
      editUserDialog(item) {
        const self = this;

        self.selected_user = item;

        self.edit_user.user_name = item.user_name;
        self.edit_user.email = item.email;
        self.edit_user.account_type = item.account_type;

        self.edit_user_dialog = true
      },
      editUserPermissionsDialog(item) {
        const self = this;

        self.selected_user = item;

        self.edit_user_permissions_dialog = true
      },
      removeUserDialog(item) {
        const self = this;

        self.item_index = self.workspace_users.indexOf(item);
        self.selected_user = item;
        self.remove_user_dialog = true
      },
      cancelRemoveUser() {
        const self = this;
        self.remove_user_dialog = false;
      },
      removeUser() {
        let self = this,
          url = 'workspaces/' + parseInt(self.$route.params.workspace_id) + '/users/' + self.selected_user.id;

        self.is_loading = true;

        axiosInstance.delete(url).then(function (response) {
          //  self.is_loading = false;
          // self.workspace_users.splice(self.item_index, 1)
          self.$toastr.s("Removed user successfully");
          self.getUsers();
        }).catch(function (err) {
          //  self.is_loading = false;
          self.$toastr.e("Error removing user");
          console.log(err)
        });

        self.remove_user_dialog = false;

      },
      getUsers() {
        let self = this,
          url = 'workspaces/' + parseInt(self.$route.params.workspace_id) + '/users/';

        self.loadingDataTable = true;

        axiosInstance.get(url).then(function (response) {
          self.workspace_users = response.data;
          self.loadingDataTable = false;
        }).catch(function (err) {
          self.loadingDataTable = false;
          self.$toastr.e("Error getting users")
          console.log(err)
        })
      },
    },
    beforeMount() {
      this.getUsers();
    }
  }
</script>




// WEBPACK FOOTER //
// src/components/workspace/WorkspaceUsers.vue